import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const recipientMessagesStatus: Record<string, string> = {
  pending: 'Pendente',
  sent: 'Enviado',
  seen: 'Visto',
  failed: 'Falha ao enviar'
}

export const recipientMessagesStatusOptions = strategyToOptions(recipientMessagesStatus);
